import React from 'react';
import add from '../images/ui-icons/add.svg';
import chevronRight from '../images/ui-icons/chevron-right.svg';
import edit from '../images/ui-icons/edit.svg';
import microphone from '../images/ui-icons/microphone.svg';
import qrCode from '../images/ui-icons/qr-code.svg';
import settings from '../images/ui-icons/settings.svg';
import trash from '../images/ui-icons/trash.svg';

// The Kabilah phone app's UI icons (copied from kabilah-react-native/assets/
// icons/ui), drawn as a mask so they take the text color like the app's.
const ICONS = { add, 'chevron-right': chevronRight, edit, microphone, 'qr-code': qrCode, settings, trash };

const UiIcon = ({ name, size = 24 }) => {
  const url = ICONS[name];
  return (
    <span
      className="report-icon"
      aria-hidden="true"
      style={{ width: size, height: size, WebkitMaskImage: `url(${url})`, maskImage: `url(${url})` }}
    />
  );
};

export default UiIcon;
